// extracted by mini-css-extract-plugin
export default {"navbar":"Nav_navbar__W0a-E"};